import * as React from "react";
import {TrackerPolicy} from "@models/tracker-policy";
import Table from "@components/public-users/list/Table";
import {Button, Card} from "antd";
import SearchComponent from "@components/public-users/list/Search";
import whitListData from "@hocs/withListData";
import api from "@api/public-user";
import withPaginationComponent from "@hocs/withPaginationComponent";



interface PropsFromHoc {
  data          :TrackerPolicy[];
  isFetched     : boolean;
  currentPage   : number;
  search        : (params: object | null) => void;
  onDeleteItem  : (id:string) => void;
}


type AllProps = PropsFromHoc ;

const ListPage: React.FC<AllProps> = (props) => {
  const {data, isFetched, currentPage, search} = props;
  
  const deleteTrackerPolicy = (item: TrackerPolicy): any => {
  };
  
  return (
    <div>
      <div className={"page-table-wrapper"}>
        <Card className={`page-table-header`} bordered={false}>
          <SearchComponent search={search}/>
        </Card>
        
        <Table
          data={data}
          currentPage={currentPage}
          rowKey={record => record.id}
          deleteFn={deleteTrackerPolicy}
          loading={!isFetched}
        />
      </div>
    </div>
  );
};


export default whitListData(
  withPaginationComponent(ListPage),
  {
    fetchRequest: api.getList,
    paginationOnScroll: false
  }
);
